/* ==========================================================================
   NOVONUTRA CUSTOM HEADER
   ========================================================================== */

(function () {
  'use strict';

  function initCustomHeader(header) {
    if (!header || header.dataset.customHeaderInitialized === 'true') {
      return;
    }

    header.dataset.customHeaderInitialized = 'true';

    var toggle = header.querySelector('[data-custom-header-toggle]');
    var menu = header.querySelector('[data-custom-header-menu]');
    var submenuToggles = header.querySelectorAll('[data-mobile-submenu-toggle]');

    if (!toggle || !menu) {
      return;
    }


    /* ======================================================================
       OPEN / CLOSE MOBILE MENU
       ====================================================================== */

    function openMenu() {
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', 'Close menu');

      menu.setAttribute('aria-hidden', 'false');
      menu.classList.add('is-open');

      document.documentElement.classList.add('custom-header-menu-open');
    }


    function closeMenu() {
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Open menu');

      menu.setAttribute('aria-hidden', 'true');
      menu.classList.remove('is-open');

      document.documentElement.classList.remove('custom-header-menu-open');

      submenuToggles.forEach(function (submenuToggle) {
        submenuToggle.setAttribute('aria-expanded', 'false');

        var submenu = submenuToggle
          .closest('.custom-header__mobile-item')
          ?.querySelector('.custom-header__mobile-submenu');

        if (submenu) {
          submenu.classList.remove('is-open');
        }
      });
    }


    toggle.addEventListener('click', function () {
      var isOpen = toggle.getAttribute('aria-expanded') === 'true';

      if (isOpen) {
        closeMenu();
      } else {
        openMenu();
      }
    });


    /* ======================================================================
       MOBILE SUBMENUS
       ====================================================================== */

    submenuToggles.forEach(function (submenuToggle) {

      submenuToggle.addEventListener('click', function () {

        var parentItem = submenuToggle.closest(
          '.custom-header__mobile-item'
        );

        if (!parentItem) {
          return;
        }

        var submenu = parentItem.querySelector(
          '.custom-header__mobile-submenu'
        );

        if (!submenu) {
          return;
        }

        var isOpen =
          submenuToggle.getAttribute('aria-expanded') === 'true';


        submenuToggle.setAttribute(
          'aria-expanded',
          isOpen ? 'false' : 'true'
        );

        submenu.classList.toggle(
          'is-open',
          !isOpen
        );

      });

    });


    /* ======================================================================
       CLOSE MENU WHEN CLICKING A LINK
       ====================================================================== */

    var mobileLinks = header.querySelectorAll(
      '.custom-header__mobile-menu a'
    );

    mobileLinks.forEach(function (link) {

      link.addEventListener('click', function () {
        closeMenu();
      });

    });


    /* ======================================================================
       CLOSE MENU WITH ESCAPE
       ====================================================================== */

    document.addEventListener('keydown', function (event) {

      if (event.key === 'Escape') {

        var isOpen =
          toggle.getAttribute('aria-expanded') === 'true';

        if (isOpen) {
          closeMenu();
        }

      }

    });


    /* ======================================================================
       CLOSE MENU WHEN CLICKING OUTSIDE HEADER
       ====================================================================== */

    document.addEventListener('click', function (event) {

      var isOpen =
        toggle.getAttribute('aria-expanded') === 'true';

      if (!isOpen) {
        return;
      }

      if (!header.contains(event.target)) {
        closeMenu();
      }

    });

  }


  /* ==========================================================================
     INITIALIZE CURRENT HEADERS
     ========================================================================== */

  function initializeCustomHeaders() {

    var headers = document.querySelectorAll(
      '[data-custom-header]'
    );

    headers.forEach(function (header) {
      initCustomHeader(header);
    });

  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initializeCustomHeaders
    );

  } else {

    initializeCustomHeaders();

  }


  /* ==========================================================================
     SHOPIFY THEME EDITOR SUPPORT
     ========================================================================== */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      var header = event.target.querySelector(
        '[data-custom-header]'
      );

      if (header) {
        initCustomHeader(header);
      }

    }
  );

})();